import { useQuery } from '@tanstack/react-query';
import { useMsal } from '@azure/msal-react';
import {
  fetchMostViewedRegulations,
  fetchNewestRegulations,
  fetchSearchRegulations,
  fetchUpdatedRegulations,
} from './Dashboard.services.ts';

import type { ServicePropsType } from './Dashboard.types.ts';

export const useService = ({
  topic = null,
  type = [],
  unit = [],
  search = '',
  activeKey,
  pageSize = 5,
  newestPage = 1,
  updatedPage = 1,
  mostViewedPage = 1,
}: ServicePropsType) => {
  const { accounts } = useMsal();
  const hasAccount = accounts.length > 0;

  const { data: newestRegulations } = useQuery({
    queryKey: ['newestRegulations', { pageSize, newestPage }],
    queryFn: () => fetchNewestRegulations({ pageSize, newestPage }),
    enabled: hasAccount && activeKey === '1',
    retry: false,
  });
  const { data: updatedRegulations } = useQuery({
    queryKey: ['updatedRegulations', { pageSize, updatedPage }],
    queryFn: () => fetchUpdatedRegulations({ pageSize, updatedPage }),
    enabled: hasAccount && activeKey === '2',
    retry: false,
  });
  const { data: mostViewedRegulations } = useQuery({
    queryKey: ['mostViewedRegulations', { pageSize, mostViewedPage }],
    queryFn: () => fetchMostViewedRegulations({ pageSize, mostViewedPage }),
    enabled: hasAccount && activeKey === '3',
    retry: false,
  });
  const { data: searchedRegulations } = useQuery({
    queryKey: ['searchedRegulations', { topic, type, unit, search }],
    queryFn: () => fetchSearchRegulations({ topic, type, unit, search }),
    enabled: Boolean(type || search || unit || topic),
    retry: false,
  });
  return { newestRegulations, updatedRegulations, mostViewedRegulations, searchedRegulations };
};